import { Text } from "@amzn/stencil-react-components/text";
import { StencilThemeFont } from "@amzn/stencil-react-theme-default";
import styled from "@emotion/styled";
import React from "react";
import { FormattedMessage } from "react-intl";

/**
 * Bullet list item with pre-configured style
 */
const ListItem = styled.li`
  line-height: 2;
`;

const List = styled.ul`
  list-style-position: outside;
  padding-left: 30px;
`;

interface ListProps {
  /**
   * A list of i18n ids that maps into messages of bullet list items.
   */
  i18nIds: string[];

  /**
   * The data-test-id that will be used for testing
   */
  dataTestId?: string;

  /**
   * The font size of the text displayed in the bullet list
   */
  fontSize?: keyof StencilThemeFont["size"] | string | number;

  /**
   * The font weight of the text displayed in the bullet list
   */
  fontWeight: keyof StencilThemeFont["fontWeight"] | number;

  /**
   * String literals to be replaced in the text.
   */
  stringLiterals?: Record<string, string>;
}

/**
 * A list of items that is .
 * @param i18nIds A list of i18n ids that maps into messages of bullet list items.
 * @param dataTestId The data-test-id that will be used for testing
 * @param fontSize The font size of the text displayed in the bullet list
 * @param fontWeight The font weight of the text displayed in the bullet list
 * @param stringLiterals String literals to be replaced in the text.
 */
export const BulletList = ({
  i18nIds,
  dataTestId,
  fontSize,
  fontWeight,
  stringLiterals,
}: ListProps): JSX.Element => {
  return (
    <List data-test-id={dataTestId}>
      {i18nIds.map((id) => (
        <Text key={id} fontSize={fontSize} fontWeight={fontWeight}>
          <ListItem>
            <FormattedMessage id={id} values={{ ...stringLiterals }} />
          </ListItem>
        </Text>
      ))}
    </List>
  );
};

BulletList.defaultProps = {
  fontSize: "T200",
  fontWeight: "normal",
};
